import { useSelector } from "react-redux"
import { Alert } from "@material-ui/lab"
import { useState } from "react"
import { ButtonGroup, Button } from "@material-ui/core"
import TPagos from "."
import TPlanPagos from "../TPlanPagos"
import VHistorialAtraso from "../VHistorialAtraso"
const VistaComrpas = () => {
    const { referencia } = useSelector(store => store.cliente)
    const [vista, setVista] = useState("depositos") // puede ser: depositos | plan | atrasos

    if (!referencia) {
        return <Alert className="alerta" severity="info">Seleccione un cliente</Alert>
    }

    return (
        <div style={{ marginTop: "10px" }}>
            <div style={{ marginBottom: "10px", display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
                <ButtonGroup disableElevation variant="contained" color="primary">
                    <Button 
                        onClick={() => setVista("depositos")} 
                        color={vista === "depositos" ? 'secondary' : 'default'}
                    >
                        Depositos
                    </Button>
                    <Button 
                        onClick={() => setVista("plan")} 
                        color={vista === "plan" ? 'secondary' : 'default'}
                    >
                        Plan de pagos
                    </Button>
                    <Button 
                        onClick={() => setVista("atrasos")} 
                        color={vista === "atrasos" ? 'secondary' : 'default'}
                    >
                        Atrasos
                    </Button>
                </ButtonGroup>
            </div>

            {
                vista === "depositos" ? <TPagos /> :
                vista === "plan" ? <TPlanPagos /> :
                <VHistorialAtraso />
            }
        </div>
    )
}

export default VistaComrpas
